import script from "./GebaudeReinigungView.vue?vue&type=script&setup=true&lang=js"
export * from "./GebaudeReinigungView.vue?vue&type=script&setup=true&lang=js"

import "./GebaudeReinigungView.vue?vue&type=style&index=0&id=9bf5a7e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9bf5a7e6"]])

export default __exports__